import AsoHeader from '../../../components/Aso/Header';
import AsoValidaTokenEmail from '../../../components/Aso/Register/AsoValidaTokenEmail';

export function AsoRegistroValidaTokenEmail() {

  return (
    <div>
      <AsoHeader />
      <AsoValidaTokenEmail />
    </div>
  );
}
